(function(){
  var afterMain = [
    'https://cdn.shopify.com/s/files/1/0987/1716/files/HP-17.jpg?v=1793649121',
    'https://cdn.shopify.com/s/files/1/0987/1716/files/HP-18.jpg?v=1793649121'
  ];
  var lifestyle = [
    'https://cdn.shopify.com/s/files/1/0987/1716/files/HP-19.jpg?v=1793649121',
    'https://cdn.shopify.com/s/files/1/0987/1716/files/HP-20.jpg?v=1793649121',
    'https://cdn.shopify.com/s/files/1/0987/1716/files/HP-21.jpg?v=1793649121'
  ];
  var catalog = {
    black: {
      label: 'Black', available: true,
      images: {
        1: 'https://cdn.shopify.com/s/files/1/0987/1716/files/PDP-S-01.jpg?v=1793649121',
        3: 'https://cdn.shopify.com/s/files/1/0987/1716/files/Black-3-Pack_ad8c8b28-3a03-4cd0-bcb6-3e8acb424df6.jpg?v=1791312211',
        5: 'https://cdn.shopify.com/s/files/1/0987/1716/files/Black-5-Pack_2fc0eeeb-2062-45b4-bc15-87324bedac20.jpg?v=1791312211'
      },
      extras: afterMain.concat([lifestyle[0], lifestyle[1], lifestyle[2]]),
      packs: {
        1: { qty:1, price: 19.99, label: '1 Clip' },
        3: { qty:3, price: 49.99, label: '3 Pack' },
        5: { qty:5, price: 59.99, label: '5 Pack' }
      },
      variantId: 32361772220503
    },
    blue: {
      label: 'Blue', available: true,
      images: {
        1: 'https://cdn.shopify.com/s/files/1/0987/1716/files/PDP-S-02.jpg?v=1793649121',
        3: 'https://cdn.shopify.com/s/files/1/0987/1716/files/Blue-3-Pack_79241a54-b111-48b2-877e-3e3e9c47bc4e.jpg?v=1791312211',
        5: 'https://cdn.shopify.com/s/files/1/0987/1716/files/Blue-5-Pack_dace00b4-8018-40c6-8db7-a589cf18f3e8.jpg?v=1791312211'
      },
      extras: afterMain.concat([lifestyle[0], lifestyle[1], lifestyle[2]]),
      packs: {
        1: { qty:1, price: 19.99, label: '1 Clip' },
        3: { qty:3, price: 49.99, label: '3 Pack' },
        5: { qty:5, price: 59.99, label: '5 Pack' }
      },
      variantId: 32361772384343
    },
    green: {
      label: 'Green', available: true,
      images: {
        1: 'https://cdn.shopify.com/s/files/1/0987/1716/files/PDP-S-03.jpg?v=1793649121',
        3: 'https://cdn.shopify.com/s/files/1/0987/1716/files/Green-3-Pack_bfcfc2c3-3da8-45b8-ba56-5492a649dc94.jpg?v=1791312211',
        5: 'https://cdn.shopify.com/s/files/1/0987/1716/files/Green-5-Pack_179b6e39-76dd-4c3f-a654-f4e519a76630.jpg?v=1791312211'
      },
      extras: afterMain.concat([lifestyle[0], lifestyle[1], lifestyle[2]]),
      packs: {
        1: { qty:1, price: 19.99, label: '1 Clip' },
        3: { qty:3, price: 49.99, label: '3 Pack' },
        5: { qty:5, price: 59.99, label: '5 Pack' }
      },
      variantId: 32361775661143
    },
    red: {
      label: 'Red', available: true,
      images: {
        1: 'https://cdn.shopify.com/s/files/1/0987/1716/files/PDP-S-04.jpg?v=1793649121',
        3: 'https://cdn.shopify.com/s/files/1/0987/1716/files/Red-3-Pack_5e3f6b28-1f25-44b7-b93d-725dbc5949ba.jpg?v=1791312211',
        5: 'https://cdn.shopify.com/s/files/1/0987/1716/files/Red-5-Pack_b87e292b-6591-4308-967e-ac2f22f8f1c3.jpg?v=1791312211'
      },
      extras: afterMain.concat([lifestyle[0], lifestyle[1], lifestyle[2]]),
      packs: {
        1: { qty:1, price: 19.99, label: '1 Clip' },
        3: { qty:3, price: 49.99, label: '3 Pack' },
        5: { qty:5, price: 59.99, label: '5 Pack' }
      },
      variantId: 32361775956055
    },
    yellow: {
      label: 'Yellow', available: true,
      images: {
        1: 'https://cdn.shopify.com/s/files/1/0987/1716/files/PDP-S-05.jpg?v=1793649121',
        3: 'https://cdn.shopify.com/s/files/1/0987/1716/files/Yellow-3-Pack_2e0b938a-6cab-4eaa-a45b-e68d3404c072.jpg?v=1791312210',
        5: 'https://cdn.shopify.com/s/files/1/0987/1716/files/Yellow-5-Pack_3ce8a19b-ffe5-4114-b468-df2f5a7998e1.jpg?v=1791312211'
      },
      extras: afterMain.concat([lifestyle[0], lifestyle[1], lifestyle[2]]),
      packs: {
        1: { qty:1, price: 19.99, label: '1 Clip' },
        3: { qty:3, price: 49.99, label: '3 Pack' },
        5: { qty:5, price: 59.99, label: '5 Pack' }
      },
      variantId: 39582020501591
    },
    pink: {
      // Pink Gen 2 single (FC G2 PK). Starts unavailable; enabled only when the
      // storefront confirms the product is live + in stock (Liquid data attr or /products/<handle>.js).
      label: 'Pink', available: false, comingSoon: true,
      handle: 'new-gen-2-0-klitch-sport-footwear-clip-pink',
      images: {
        1: 'https://cdn.shopify.com/s/files/1/0987/1716/files/PDP-S-09_Pink_A.jpg?v=1793749235'
      },
      extras: afterMain.concat([lifestyle[0], lifestyle[1], lifestyle[2]]),
      packs: {
        1: { qty:1, price: 19.99, label: '1 Clip' },
        3: { qty:3, price: 49.99, label: '3 Pack' },
        5: { qty:5, price: 59.99, label: '5 Pack' }
      },
      variantId: 44609736343639
    }
  };

  var root = document.getElementById('k-hero-buy');
  if (!root) return;
  var img = document.getElementById('k-hero-img');
  var priceEl = document.getElementById('k-hero-price');
  var variantEl = document.getElementById('k-hero-variant');
  var atc = document.getElementById('k-hero-atc');
  var oosEl = document.getElementById('k-hero-oos');
  var thumbsEl = document.getElementById('k-hero-thumbs');
  var color = root.getAttribute('data-color') || 'black';
  var pack = root.getAttribute('data-pack') || '3';
  var slide = 0;
  var slides = [];

  function availableLabels(){
    var out = [];
    Object.keys(catalog).forEach(function(k){ if (catalog[k].available) out.push(catalog[k].label); });
    if (out.length < 2) return out.join('');
    return out.slice(0, -1).join(', ') + ', or ' + out[out.length - 1];
  }

  function markSwatches(){
    root.querySelectorAll('.k-swatch').forEach(function(btn){
      var c = catalog[btn.getAttribute('data-color')];
      if (!c) return;
      btn.classList.toggle('is-oos', !c.available);
      btn.setAttribute('title', c.label + (c.available ? '' : (c.comingSoon ? ' — coming soon' : ' — out of stock')));
    });
  }

  // Liquid-provided availability (data-k-available="true|false") wins over JS defaults.
  root.querySelectorAll('.k-swatch[data-k-available]').forEach(function(btn){
    var c = catalog[btn.getAttribute('data-color')];
    if (c) c.available = btn.getAttribute('data-k-available') === 'true';
  });

  function money(n){ return '$' + n.toFixed(2); }

  function unique(arr){
    var out = [], seen = {};
    for (var i=0;i<arr.length;i++){
      if (!arr[i] || seen[arr[i]]) continue;
      seen[arr[i]] = 1;
      out.push(arr[i]);
    }
    return out;
  }

  function cdnSize(url, w){
    if (!url) return url;
    var base = url.split('&width=')[0].split('?width=')[0];
    var sep = base.indexOf('?') >= 0 ? '&' : '?';
    return base + sep + 'width=' + w;
  }

  function buildSlides(){
    var c = catalog[color];
    if (!c) return [];
    var main = (c.images && (c.images[pack] || c.images[3] || c.images[1])) || '';
    return unique([main].concat(c.extras || []));
  }

  function renderThumbs(){
    thumbsEl.innerHTML = '';
    for (var i=0;i<slides.length;i++){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'k-hero-thumb' + (i===slide ? ' is-active' : '');
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-label', 'Image ' + (i+1));
      b.setAttribute('aria-selected', i===slide ? 'true' : 'false');
      var t = document.createElement('img');
      t.src = cdnSize(slides[i], 160);
      t.alt = '';
      t.loading = 'lazy';
      t.width = 160;
      t.height = 160;
      b.appendChild(t);
      (function(idx){ b.addEventListener('click', function(){ slide = idx; showSlide(); }); })(i);
      thumbsEl.appendChild(b);
    }
  }

  function showSlide(){
    if (!slides.length) return;
    if (slide < 0) slide = slides.length - 1;
    if (slide >= slides.length) slide = 0;
    var raw = slides[slide];
    img.src = cdnSize(raw, 1600);
    img.srcset = cdnSize(raw, 800) + ' 800w, ' + cdnSize(raw, 1200) + ' 1200w, ' + cdnSize(raw, 1600) + ' 1600w';
    img.sizes = '(max-width: 900px) 100vw, 560px';
    img.alt = 'Klitch Footwear Clip, ' + (catalog[color] ? catalog[color].label : '');
    var thumbs = thumbsEl.querySelectorAll('.k-hero-thumb');
    for (var i=0;i<thumbs.length;i++){
      thumbs[i].classList.toggle('is-active', i===slide);
      thumbs[i].setAttribute('aria-selected', i===slide ? 'true' : 'false');
    }
  }

  function sync(){
    var c = catalog[color];
    if (!c) return;
    var p = c.packs[pack] || c.packs[3];
    root.setAttribute('data-color', color);
    root.setAttribute('data-pack', pack);
    root.classList.toggle('is-oos', !c.available);
    if (oosEl) {
      oosEl.textContent = c.available ? '' : (c.label + (c.comingSoon ? ' is coming soon' : ' is currently out of stock') + ' — pick ' + availableLabels() + '.');
    }
    atc.disabled = !c.available;
    markSwatches();
    variantEl.value = String(c.variantId);
    var qtyEl = document.getElementById('k-hero-qty') || root.querySelector('input[name="quantity"]');
    if (qtyEl) qtyEl.value = String(p.qty || pack);
    priceEl.textContent = money(p.price);
    atc.textContent = c.available ? ('Add to cart — ' + p.label) : (c.comingSoon ? 'Coming soon' : 'Out of stock');
    root.querySelectorAll('.k-swatch').forEach(function(btn){
      btn.classList.toggle('is-active', btn.getAttribute('data-color') === color);
    });
    root.querySelectorAll('.k-pack-card').forEach(function(card){
      card.classList.toggle('active', card.getAttribute('data-pack') === String(pack));
    });
    slides = buildSlides();
    slide = 0;
    renderThumbs();
    showSlide();
  }

  root.querySelectorAll('.k-swatch').forEach(function(btn){
    btn.addEventListener('click', function(){ color = btn.getAttribute('data-color'); sync(); });
  });
  root.querySelectorAll('.k-pack-card').forEach(function(card){
    card.addEventListener('click', function(){ pack = card.getAttribute('data-pack'); sync(); });
  });
  var heroForm = document.getElementById('k-hero-form');
  if (heroForm) heroForm.addEventListener('submit', function(ev){
    var c = catalog[color];
    if (!c || !c.available) ev.preventDefault();
  });
  document.getElementById('k-hero-prev').addEventListener('click', function(){ slide--; showSlide(); });
  document.getElementById('k-hero-next').addEventListener('click', function(){ slide++; showSlide(); });
  sync();

  // If Liquid could not tell (no data attr), confirm Pink via the storefront product JSON.
  // A DRAFT/unpublished product returns 404 here, so Pink simply stays "coming soon".
  Object.keys(catalog).forEach(function(k){
    var c = catalog[k];
    if (!c.handle || c.available) return;
    var sw = root.querySelector('.k-swatch[data-color="' + k + '"]');
    if (sw && sw.hasAttribute('data-k-available')) return;
    if (!window.fetch) return;
    fetch('/products/' + c.handle + '.js', {credentials:'same-origin', headers:{'Accept':'application/json'}})
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(p){
        if (!p || !p.available) return;
        c.available = true;
        if (p.variants && p.variants[0] && p.variants[0].id) c.variantId = p.variants[0].id;
        sync();
      })
      .catch(function(){});
  });
})();
